export const ApiConfig = {
  API_URL: window.env.CONFIG_API_GATEWAY_URL,
  BUILD_NUMBER: window.env.CONFIG_BUILD_NUMBER,
  BUILD_TIME: window.env.CONFIG_BUILD_TIME,
  PROJECT_ID: {
    USER_SERVICE: window.env.CONFIG_NODEJS_SCYBER_ADMIN_SERVICE_ID,
    UPLOAD_SERVICE: window.env.CONFIG_NODEJS_SCYBER_MANAGER_SERVICE_ID,
  },
};

export const API_OAUTH_ROUTER = {
  VERSION: "v1",
  get API_LOGIN() {
    return `${this.VERSION}/auth/login`;
  },
  get VERIFY_OTP_LOGIN() {
    return `${this.VERSION}/auth/verify-otp-login`;
  },
  get VERIFY_OTP_FORGOT_PASSWORD() {
    return `${this.VERSION}/auth/verify-otp-forgot-password`;
  },
  get RESET_PASSWORD() {
    return `${this.VERSION}/auth/reset-password`;
  },
  get CHANGE_PASSWORD() {
    return `${this.VERSION}/auth/change-password`;
  },
};

export const API_UPLOAD_ROUTER = {
  VERSION: "v1",
  get API_UPLOAD() {
    return `${this.VERSION}/upload/files`;
  },
  get API_SHORT() {
    return `${this.VERSION}/upload/short`;
  },
};

export const API_ADMIN_ROUTER = {
  VERSION: "v1",

  API_CREATE_ADMIN() {
    return `${this.VERSION}/admins/create`;
  },
  API_UPDATE_ADMIN(id: string) {
    return `${this.VERSION}/admins/${id}/update`;
  },
  API_GET_ADMIN() {
    return `${this.VERSION}/admins`;
  },
  API_GET_ADMIN_COUNT_TAB() {
    return `${this.VERSION}/admins/count-tab`;
  },
  API_DETAIL_ADMIN(id: string) {
    return `${this.VERSION}/admins/${id}/detail`;
  },
  API_CHANGE_STATUS_ADMIN(id: string) {
    return `${this.VERSION}/admins/${id}/change-status`;
  },
  API_RESET_PASSWORD_ADMIN(id: string) {
    return `${this.VERSION}/admins/${id}/reset-password`;
  },

  API_UPDATE_PROFILE_ADMIN() {
    return `${this.VERSION}/admins/update-profile`;
  },
};

export const API_BRANDS_ROUTER = {
  VERSION: "v1",

  API_CREATE_BRAND() {
    return `${this.VERSION}/brands/create`;
  },
  API_UPDATE_BRAND(id: string) {
    return `${this.VERSION}/brands/${id}/update`;
  },
  API_GET_BRAND() {
    return `${this.VERSION}/brands`;
  },
  API_GET_BRAND_COUNT_TAB() {
    return `${this.VERSION}/brands/count-tab`;
  },
  API_DETAIL_BRAND(id: string) {
    return `${this.VERSION}/brands/${id}/detail`;
  },
  API_CHANGE_STATUS_BRAND(id: string) {
    return `${this.VERSION}/brands/${id}/change-status`;
  },
  API_RESET_PASSWORD_BRAND(id: string) {
    return `${this.VERSION}/brands/${id}/reset-password`;
  },
  API_GET_BRAND_PROMOTIONS() {
    return `${this.VERSION}/brands/get-brand-promotions`;
  },
};

export const API_PROMOTION_CAMPAIGN_TYPES_ROUTER = {
  VERSION: "v1",

  API_GET_PROMOTION_CAMPAIGNS() {
    return `${this.VERSION}/promotion-campaign-types`;
  },
  API_GET_PROMOTION_CAMPAIGNS_LIST_BRAND() {
    return `${this.VERSION}/promotion-campaign-types/get-list-brands`;
  },
  API_DETAIL_PROMOTION_CAMPAIGN_DETAIL(id: string) {
    return `${this.VERSION}/promotion-campaign-types/${id}/detail`;
  },
  API_ASSIGN_PROMOTION_BRAND() {
    return `${this.VERSION}/promotion-campaign-types/assign`;
  },
};

export const API_BANNER_ROUTER = {
  VERSION: "v1",
  get API_GET_BANNERS() {
    return `${this.VERSION}/banners`;
  },
  get API_GET_BANNERS_COUNT_TAB() {
    return `${this.VERSION}/banners/count`;
  },

  API_CREATE_UPSERT() {
    return `${this.VERSION}/banners/upsert`;
  },

  API_CREATE_BANNER() {
    return `${this.VERSION}/banners/create`;
  },
  API_UPDATE_BANNER(id: string) {
    return `${this.VERSION}/banners/${id}/update`;
  },
  API_CHANGE_STATUS_BANNER(id: string) {
    return `${this.VERSION}/banners/${id}/change-status`;
  },
  API_GET_BANNER_DETAIL(id: string) {
    return `${this.VERSION}/banners/${id}/detail`;
  },
};

export const API_APP_VERSION_ROUTER = {
  VERSION: "v1",
  get API_GET_APP_VERSION() {
    return `${this.VERSION}/app-versions`;
  },

  API_CREATE_APP_VERSION() {
    return `${this.VERSION}/app-versions/create`;
  },
  API_UPDATE_APP_VERSION(id: string) {
    return `${this.VERSION}/app-versions/${id}/update`;
  },
};

export const API_COMPANIES_ROUTER = {
  VERSION: "v1",
  get API_GET_COMPANIES() {
    return `${this.VERSION}/companies`;
  },

  get API_GET_COMPANIES_COUNT_TAB() {
    return `${this.VERSION}/companies/count-tab`;
  },

  API_CREATE_COMPANIES() {
    return `${this.VERSION}/companies/create`;
  },
  API_UPDATE_COMPANIES(id: string) {
    return `${this.VERSION}/companies/${id}/update`;
  },
  API_GET_COMPANIES_DETAIL(id: string) {
    return `${this.VERSION}/companies/${id}/detail`;
  },
  API_CHANGE_STATUS_COMPANIES(id: string) {
    return `${this.VERSION}/companies/${id}/change-status`;
  },
};

export const API_CONFIGS_ROUTER = {
  API_CONFIGS_PUBLIC() {
    return `public/configs`;
  },
};
